import noodleApiClient from '@/tsClient/servers/noodleApi';
import type { Resolution, ResolveConflictsResponse } from '@/typings/api-models';

type ResolveConflictsInput = {
  caseId: string;
  resolutions?: Resolution[];
  acceptAllFromSource?: {
    sourceCategory: string;
    sourceId?: string;
  };
};

const resolveConflicts = async ({
  caseId,
  resolutions,
  acceptAllFromSource,
}: ResolveConflictsInput): Promise<ResolveConflictsResponse> => {
  const response = await noodleApiClient.post(`/cases/${caseId}/resolutions`, {
    acceptAllFromSource,
    resolutions,
  });
  return response.data as ResolveConflictsResponse;
};

export type { ResolveConflictsInput };
export default resolveConflicts;
